export default __webpack_public_path__ + "static/media/caution.b1e5bc83.svg";